// Global "assistant is processing" counter (image render requests etc.) → Chat disables the send button while > 0.
const EV = "oryntix:busy";
export const beginBusy = () => window.dispatchEvent(new CustomEvent(EV, { detail: { delta: 1 } }));
export const endBusy = () => window.dispatchEvent(new CustomEvent(EV, { detail: { delta: -1 } }));
export const onBusy = (fn) => { const h = (e) => fn(e.detail?.delta || 0); window.addEventListener(EV, h); return () => window.removeEventListener(EV, h); };
